module.exports = __webpack_public_path__ + "media/images/dmc/tour-03-a14d8e9e2d3afb0034a91349717e1d7c.jpg";